<template>
  <v-row justify="space-between" class="pb-2">
    <v-col
      cols="4"
      class="mt-md-3 px-0 align-center text-center"
    >
      <div class="caption">{{ event.AwayTeamTextIDShort }}</div>

      <strong>{{ event.FavoriteTeamID == event.AwayTeamID ? event.FavoriteMoney : event.UnderdogMoney }}</strong>
    </v-col>
    <v-col
      cols="4"
      class="text-center mt-md-3 "
    >
      <div class="caption">{{ event.FavoriteTeamID == event.AwayTeamID ? event.AwayTeamTextIDShort : event.HomeTeamTextIDShort }} Points</div>
      <strong class="mt-2">{{ parseFloat(event.FavoritePoints) }}</strong>
    </v-col>
    <v-col
      cols="4"
      class="mt-md-3 px-0 text-center"
    >
      <div class="caption">{{ event.HomeTeamTextIDShort }}</div>

      <strong>{{ event.FavoriteTeamID == event.HomeTeamID ? event.FavoriteMoney : event.UnderdogMoney }}</strong>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Spread",
  props: {
    event: Object,
  },
};
</script>